var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*eslint no-useless-escape: 0*/
import React, { useState, useEffect } from 'react';
import { Button, IconButton, Grid, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Divider, InputAdornment } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { MODOS, getCodigoOfertaFormatada } from '../../../utils';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import ContainerPainel from '../../../components/container_painel';
import { BoxPrincipal, BoxBotoes } from '../../../components/form_box';
import Loading from '../../../components/loading';
import { useParams } from 'react-router-dom';
import { BotaoFechar } from '../../../components/botoes';
import { InputDados } from '../../../components/input_dados';
import { getVagaTrabalho, STATUS_API } from './atendimentos.service';
import { JornadasTrabalhoAlterar } from '../jornadas_trabalho';
export var AtendimentosDetalheVaga = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var _k = useState(true), loading = _k[0], setLoading = _k[1];
    var _l = useState(true), LoadingInicio = _l[0], setLoadingInicio = _l[1];
    var _m = useParams(), id = _m.id, modo = _m.modo;
    var _o = useState(), VagaTrabalho = _o[0], setVagaTrabalho = _o[1];
    var _p = useState(false), PopupAberto = _p[0], setPopupAberto = _p[1];
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var VagaTrabalhoAux;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!id) return [3 /*break*/, 2];
                    return [4 /*yield*/, getVagaTrabalho(id)];
                case 1:
                    VagaTrabalhoAux = _a.sent();
                    if (VagaTrabalhoAux.Status == STATUS_API.ERRO) {
                        alert(VagaTrabalhoAux.Mensagem);
                        return [2 /*return*/];
                    }
                    else {
                        setVagaTrabalho(VagaTrabalhoAux);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    alert('ID do Contrato não informado');
                    _a.label = 3;
                case 3:
                    setLoadingInicio(false);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var abrirPopup = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setPopupAberto(true);
            return [2 /*return*/];
        });
    }); };
    var handleClose = function () {
        setPopupAberto(false);
    };
    return (_jsx(ContainerPainel, __assign({ modo: modo, pagina_acima: PAGINAS.ATENDIMENTOS, pagina_especifica_permissao: FUNCIONALIDADES.ATENDIMENTO_VISUALIZAR_VAGA, link_pagina_acima: ROUTES.ATENDIMENTOS }, { children: _jsxs(BoxPrincipal, __assign({ style: { width: '80%' } }, { children: [!LoadingInicio && (_jsxs(_Fragment, { children: [_jsx(Divider, __assign({ style: { marginTop: 15, marginBottom: 15, color: 'grey' } }, { children: "CANDIDATO" })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { label: 'Oferta', value: getCodigoOfertaFormatada((_a = VagaTrabalho.oferta_vaga_trabalho) === null || _a === void 0 ? void 0 : _a.id), disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { label: 'Descri\u00E7\u00E0o Vaga', value: VagaTrabalho.descricao, disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { label: 'Cidade', value: (_c = (_b = VagaTrabalho.oferta_vaga_trabalho) === null || _b === void 0 ? void 0 : _b.cidade) === null || _c === void 0 ? void 0 : _c.nome, disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { label: 'Regime de Pena', value: (_d = VagaTrabalho.regime_reclusao_atual) === null || _d === void 0 ? void 0 : _d.nome, disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { label: 'Perfil', value: (_e = VagaTrabalho.perfil_laboral) === null || _e === void 0 ? void 0 : _e.nome, disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { label: 'Sexo', value: (_f = VagaTrabalho.sexo) === null || _f === void 0 ? void 0 : _f.nome, disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(TextField, { label: 'Tipo de Jornada de Trabalho', value: (_g = VagaTrabalho.jornada_trabalho) === null || _g === void 0 ? void 0 : _g.nome, disabled: true, InputProps: {
                                            endAdornment: (_jsx(InputAdornment, __assign({ position: 'end' }, { children: _jsxs(IconButton, __assign({ onClick: abrirPopup }, { children: [_jsx(VisibilityIcon, { style: { color: 'green' } }), " "] })) }))),
                                        }, fullWidth: true, sx: {
                                            height: '40px',
                                            '& .MuiInputBase-root': {
                                                height: '40px', // Altura do campo
                                            },
                                        } }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { label: 'Tipo de V\u00EDnculo', value: (_h = VagaTrabalho.tipo_vinculo_trabalho) === null || _h === void 0 ? void 0 : _h.nome, disabled: true }) }))] })), _jsx(BoxBotoes, { children: _jsx(BotaoFechar, { modo: modo }) }), _jsxs(Dialog, __assign({ open: PopupAberto, onClose: handleClose, maxWidth: 'xl', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "Jornada de Trabalho" }), _jsx(DialogContent, __assign({ style: { margin: 0 } }, { children: _jsx(JornadasTrabalhoAlterar, { modo: MODOS.VISUALIZAR, id: (_j = VagaTrabalho.jornada_trabalho) === null || _j === void 0 ? void 0 : _j.id, popup: true }) })), _jsx(DialogActions, __assign({ style: { padding: 20 } }, { children: _jsx(Button, __assign({ onClick: function () {
                                            setPopupAberto(false);
                                        } }, { children: "Fechar" })) }))] }))] })), loading && _jsx(Loading, {})] })) })));
};
export default AtendimentosDetalheVaga;
